import { createContext } from 'react';

export type ListType = 'incidents' | 'contracts' | 'properties' | 'tenants' | 'owners' | 'suppliers' | 'ownerContracts';

export type ListNavigationState = {
  currentPage: number;
  filters: Record<string, any>;
  scrollPosition?: number;
  selectedItemId?: string;
};

export type ListNavigationStateContextProps = {
  getListState: (listType: ListType) => ListNavigationState | null;
  setListState: (listType: ListType, state: ListNavigationState) => void;
  clearListState: (listType: ListType) => void;
};

export const ListNavigationStateContext = createContext<ListNavigationStateContextProps | null>(null);
